import type { RefObject } from 'react';

const FORM_INPUT_REF_DELAY = 100;

const giveFocusToInput = (inputRef: RefObject<HTMLInputElement>) => {
  if (inputRef.current) {
    inputRef.current.focus();
  }
};

// Ensure to use this return function in a useEffect cleanup to avoid memory leaks.
const giveFocusToInputWithDelay = (inputRef: RefObject<HTMLInputElement>) => {
  const timer = setTimeout(() => {
    giveFocusToInput(inputRef);
  }, FORM_INPUT_REF_DELAY);
  return () => clearTimeout(timer);
};

export { giveFocusToInput, giveFocusToInputWithDelay };
